import React, { useState, useCallback } from 'react';

interface UseResourceCardDragAndDropProps {
  isMultifileUploadEnabledOnSource: boolean;
  onFilesDrop: (e: React.DragEvent) => void;
}

export const useResourceCardDragAndDrop = ({
  isMultifileUploadEnabledOnSource,
  onFilesDrop,
}: UseResourceCardDragAndDropProps) => {
  const [isDragging, setIsDragging] = useState(false);
  const [dragCounter, setDragCounter] = useState(0);

  const handleDragOver = useCallback(
    (e: React.DragEvent) => {
      if (!isMultifileUploadEnabledOnSource) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.dataTransfer.types.includes('Files')) {
        setIsDragging(true);
      }
    },
    [isMultifileUploadEnabledOnSource],
  );

  const handleDragEnter = useCallback(
    (e: React.DragEvent) => {
      if (!isMultifileUploadEnabledOnSource) return;
      e.preventDefault();
      e.stopPropagation();
      setDragCounter((prev) => prev + 1);
      if (e.dataTransfer.types.includes('Files')) {
        setIsDragging(true);
      }
    },
    [isMultifileUploadEnabledOnSource],
  );

  const handleDragLeave = useCallback(
    (e: React.DragEvent) => {
      if (!isMultifileUploadEnabledOnSource) return;
      e.preventDefault();
      e.stopPropagation();
      setDragCounter((prev) => {
        const newCount = prev - 1;
        if (newCount === 0) {
          setIsDragging(false);
        }
        return newCount;
      });
    },
    [isMultifileUploadEnabledOnSource],
  );

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      if (!isMultifileUploadEnabledOnSource) return;
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
      setDragCounter(0);
      onFilesDrop(e);
    },
    [isMultifileUploadEnabledOnSource, onFilesDrop],
  );

  return {
    isDragging,
    dragHandlers: {
      onDragOver: handleDragOver,
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
    },
  };
};
